module.exports = __webpack_public_path__ + "media/images/surface_mine-c2cf150d08f250e18d734e11e57f9bfd.png";